<template>
  <div class="wrapper">
    <Header />
    <router-view></router-view>
    <Footer />
  </div>
</template>
<script>
import Header from '@/views/components/Header'
import Footer from '@/views/components/FooterHome'
export default {
  components: {
    Header,
    Footer
  },
  mounted() {
    //===== AOS Animation =====//
    AOS.init({
      duration: 1000
    });

    //===== Scroll Sticky Menu =====//
    let header = document.querySelector('.header')
    window.addEventListener('scroll', () => {
      header.classList.toggle('sticky', window.scrollY > 0)
    })
  }
}
</script>
